import { Grid } from '@mui/material'
import { SxProps } from '@mui/system'

import { ScrollFetcher } from '@/components/organisms/functionals'
import { useTranslation } from '@/core'
import { Organism, OrganismFrame } from '@/core/architecture'

import { ItemImage, ItemProps } from '../ItemImage'
import { ItemTrash } from '../ItemTrash'

export type ListItemImageProps = {
  loading: boolean
  hasNextPage: boolean
  items: ItemProps[]
  selected: ItemProps | null
  onSelected: (item: ItemProps | null) => void
  defaultValue: ItemProps['id']
  sx?: SxProps
  avatarProps?: { sx?: SxProps }
  onFetchMore: () => Promise<void>
}

export const ListItemImage: Organism<ListItemImageProps> = ({
  items,
  defaultValue,
  selected,
  onSelected,
  sx,
  avatarProps,
  loading,
  hasNextPage,
  onFetchMore,
}) => {
  const { t } = useTranslation('customProfileEditWallPaper')

  return (
    <OrganismFrame sx={{ py: 5, px: 6, ...sx }}>
      <ScrollFetcher
        component={Grid}
        componentProps={{ spacing: 3, container: true }}
        itemComponent={Grid}
        itemComponentProps={{ item: true, xs: 3 }}
        nodes={[null, ...(items || [])].map((item, index) => {
          if (!item) {
            return (
              <ItemTrash
                key={index}
                selected={selected}
                onClick={() => onSelected(item)}
                sx={avatarProps?.sx}
              />
            )
          }
          return (
            <ItemImage
              key={index}
              item={item}
              selected={selected}
              defaultValue={defaultValue}
              onClick={() => onSelected(item)}
              sx={avatarProps?.sx}
            />
          )
        })}
        loading={loading}
        hasNextPage={hasNextPage}
        onFetchMore={onFetchMore}
      />
    </OrganismFrame>
  )
}
